(function ($) {
  window.customRenderFunction = function(options) {
    var type = options.type;
    var opts = options.message;

    var lightboxContent = $('<div/>', {
        'class': 'lb-main-content'
    });
    $(lightboxContent).addClass('lb-' + type);

    var icon = $('<div/>', {'id': 'lightbox-top-icon'}).appendTo($(lightboxContent));
    $('<span/>', {'class': opts.icon}).appendTo($(icon));

    //Ak je atribút empty, vrátim lightbox, nedávam nič do jeho tela
    if(options.empty && options.empty === true)
      return lightboxContent;

    var title = $('<div/>', {'class': 'lb-title'}).appendTo($(lightboxContent));
    $('<h2/>', {'html': opts.title}).appendTo($(title));

    if(opts.content) {
      var content = $('<div/>', {'class': 'lb-content'}).appendTo($(lightboxContent));
      $('<p>' + opts.content + '</p>').appendTo($(content));
    }

    var button = $('<a/>', {
        'id': 'hide-lightbox',
        'href': 'javascript:void(0)',
        'text': opts.close
    }).appendTo($(lightboxContent));

    //Čo má zavrieť lightbox
    $().lightbox.registerCloser(button);

    return lightboxContent;
  };

  window.popupWriteForm = function (id, locale, recaptchaKey) {
    //Nastavenie localizacie
    var texts = [];
    switch(locale) {
      case 'sk':
          texts.name = 'Vaše meno';
          texts.email = 'Váš e-mail';
          texts.message = 'Vaša správa';
          texts.send = 'Odoslať';
          texts.close = 'Zavrieť';
          texts.wrongFormat = 'Nesprávny formát';
      break;
      case 'en':
          texts.name = 'Your name';
          texts.email = 'Your e-mail';
          texts.message = 'Your message';
          texts.send = 'Send';
          texts.close = 'Close';
          texts.wrongFormat = 'Incorrect format';
      break;
      case 'de':
          texts.name = 'Ihr Name';
          texts.email = 'Ihre E-mail';
          texts.message = 'Ihre Nachricht';
          texts.send = 'Schicken';
          texts.close = 'in der Nähe';
          texts.wrongFormat = 'Falsches Format';
      break;
      default:
          texts.name = 'Vaše jméno';
          texts.email = 'Váš e-mail';
          texts.message = 'Vaše zpráva';
          texts.send = 'Odeslat';
          texts.close = 'Zavřít';
          texts.wrongFormat = 'Nesprávný formát';
      break;
    }

    var options = {id: id, locale: texts, icon: 'icon-tuzka'};

    //Funkcia na renderovanie obsahu v lightboxe
    var sendFormContent = function(options) {

      var locale = options.locale;
      var lightboxContent = $('<div/>', {
          'class': 'lb-main-content'
      });

      var icon = $('<div/>', {'id': 'lightbox-top-icon'}).appendTo($(lightboxContent));
      $('<span/>', {'class': 'sa-icon ' + options.icon}).appendTo($(icon));

      var sendForm = $('<form/>', {
        'id': 'lb-send-form',
        'class': 'lb-send-form'
      }).appendTo(lightboxContent);
      $('<input/>', {
        'id': 'lb-send-name',
        'name': 'name',
        'class': 'lb-send-name lb-send-input',
        'type': 'text',
        'placeholder': locale.name,
        onblur: "this.placeholder = '" + locale.name + "'",
        onfocus: "this.placeholder = ''"
      }).appendTo(sendForm);
      $('<input/>', {
        'id': 'lb-send-email',
        'name': 'email',
        'class': 'lb-send-email lb-send-input',
        'type': 'email',
        'placeholder': locale.email,
        onblur: "this.placeholder = '" + locale.email + "'",
        onfocus: "this.placeholder = ''",
        'required': 'true'
      }).appendTo(sendForm);
      $('<textarea/>', {
        'id': 'lb-send-message',
        'name': 'message',
        'class': 'lb-send-message lb-send-textarea',
        'type': 'message',
        'placeholder': locale.message,
        onblur: "this.placeholder = '" + locale.message + "'",
        onfocus: "this.placeholder = ''",
        'required': 'true'
      }).appendTo(sendForm);

      if (recaptchaKey) {
        $('<div />', {
          'id': 'lb-send-recaptcha',
          'class': 'g-recaptcha',
          'style': 'margin-bottom: 1rem;',
        }).appendTo(sendForm);
      }

      var button = $('<input/>', {
        'id': 'send-form',
        'type': 'submit',
        'value': locale.send
      }).appendTo(sendForm);

      let observer;

      // $('body').on('submit', '#lb-send-form', function() {
      $('body').unbind('submit', '#lb-send-form').bind('submit', '#lb-send-form', function () {
        const recaptchaResponse = window.grecaptcha.getResponse();
        if (validate() && !!recaptchaResponse) {
          var data = $('#lb-send-form').serialize();
          data += `&id=${id}`;
          sendWriteMeForm(data);
          $(this).unbind('submit');
        }
        if (observer) {
          observer.disconnect();
          observer = undefined;
        }
        return false;
      });

      if (recaptchaKey) {
        try {
          const targetNode = document.body;
          const observerOptions = {
            childList: true,
            subtree: true
          };

          const observerCallback = function (mutationList) {
            for (const mutationObject of mutationList) {
              const { type, target } = mutationObject;
              if (type === 'childList' && target.id === 'lightbox') {
                const recaptchaPlaceholder = target.querySelector('#lb-send-recaptcha');

                if (observer) {
                  observer.disconnect();
                  observer = undefined;
                }

                if (recaptchaPlaceholder && !recaptchaPlaceholder.children.length) {
                  window.grecaptcha.render(recaptchaPlaceholder, {
                    'sitekey': recaptchaKey,
                  });
                }
              }
            }
          };

          if (!observer) {
            observer = new MutationObserver(observerCallback);
            observer.observe(targetNode, observerOptions);
          }

        } catch (e) {
          console.error(e);
        }
      }

      return lightboxContent;
    };

    //Validácia dát
    function validate() {
      $('.lb-wrong-format').remove();
      //Validácia emailu
      var pattern = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;
      var email = $('input[name="email"]#lb-send-email');
      if(!pattern.test($(email).val())){
        $('<p/>', {
          'class': 'lb-wrong-format',
          'text': texts.wrongFormat
        }).insertBefore($(email));
        //console.log('email not valid');
        return false;
      }
      return true;
    }

    //Odoslanie formulara
    function sendWriteMeForm(data) {
      $.ajax({
        url: '/sys/bloky/form/kontakt-form.jsp',
        data: data,
        dataType: 'json',
        success: function(res) {
          repsonseLightbox(res);
        },
        error: function(xhr, stats, errorThrown) {
          repsonseLightbox({
              type: 'error-connection',
              message: 'Internal Error'
          });
        },
        method: 'POST',
      });
    }

    //Funkcia na renderovanie lightboxu po odoslani - uspesne neuspesne
    function repsonseLightbox(opts) {
      var options = {
        type: opts.type,
        message: {
          icon: 'sa-icon',
          title: opts.message,
          close: texts.close
        }
      };
      if(opts.type === 'success')
        options.message.icon += ' icon-upsesne';
      else
        options.message.icon += ' icon-neuspesne';

      $().lightbox.changeContent('', 'icon-lightbox', window.customRenderFunction, options);
    }

    //Vytvorenie lightboxu
    var lb = $().lightbox;
    lb.create('', 'lb-send-me', sendFormContent, options);

    return lb;
  };
})(jQuery);
